import { defineAsyncComponent } from 'vue'
import { getFederatedComponentApp } from "@/common/utils/load-remote.js";
import { isSSRServer } from '@/config';
import { getFederatedDebug } from '@/common/debug';

// doc https://loftyinc.atlassian.net/wiki/spaces/WHDev/pages/402686106/site

// load  md-xxx
/**
 * name: 模块名称，md-house
 * theme: 模块主题，new-style1
 * @param {name:string,style:string} options 
 */
export const getRemoteModule = async(options) => { 
    const { name, theme } = options;
    if (isSSRServer || !name || !theme) {
        return;
    }
    try {
        const globalData = window.sitePrepareData();
        const customConfig = globalData.customConfig || {};
        const modules = customConfig.modules || [];
        const info = modules.find(item => item.name === name && item.theme === theme && item.config.isOpen);
        if (!info) {
            return;
        }
        return getFederatedComponentApp(info.config);
    } catch (error) {
        console.error("getRemoteModule error", error);
    }
}


// load   houseGrid 、 houseList
/**
 * 
 * @param defaultComponent:function
 */
export const getAsyComponent = (defaultComponent) => {
    if (!defaultComponent) {
        console.error("getRemoteComponent error", "defaultComponent is required");
        return;
    }
   
    return defineAsyncComponent(async() => {
        if (isSSRServer) {
            return defaultComponent();
        }
        try {
            const base = await defaultComponent();
            const baseDefault = base.default;
            const file = baseDefault.__loftyFile;
            // console.log("file", file);
            if (getFederatedDebug()) {
                console.log("file load module", file);
            }
            if (!file) {
                return baseDefault;
            }
            const globalData = window.sitePrepareData();
            const customConfig = globalData.customConfig || {};
            const components = customConfig.components || [];
            let info = null;
            for (let i = 0; i < components.length; i++) {
                const component = components[i];
                const config = component.config || {};
                if (config.isOpen && component.match && new RegExp(component.match).test(file)) {
                    info = config;
                    break;
                }
            }
            if (!info) {
                return baseDefault;
            }
            const res = await getFederatedComponentApp(info);
            if (!res) {
                return baseDefault;
            }
            
            return {
                mixins: [baseDefault, res]
            }
        } catch (e) {
            console.error("getRemoteComponent error", e);
        }
        return defaultComponent()
    });
}

export const getLoginComponent = async(styleMap, style) => { 
    if (isSSRServer) {
        return styleMap[style]();
    }
    try {
        const globalData = window.sitePrepareData();
        const registerDialog = globalData.customConfig?.registerDialog || {};
    
        if (registerDialog && registerDialog.isOpen && globalData.registration.style === style) {
            let res = await getFederatedComponentApp(registerDialog);
            console.log("custom login load ====", res);
            if (!res) {
                return styleMap[style]();
            }
            const base = await styleMap[style]();
            return {
                default: {
                    mixins: [base.default, res]
                }
            }
        }
    } catch (e) {
        console.error("getLoginComponent error", e);
    }
    return styleMap[style]();
}